"use client";

import React from "react";

import { Header, Footer } from "@cobasi/ds-components-react/containers";

import { useIsReactNativeApp } from "@/hooks";

export type BaseProps = {
  children: React.ReactNode;
  isLoading?: boolean;
};

const Base = ({ children }: BaseProps) => {
  const isReactNativeApp = useIsReactNativeApp();
  return (
    <>
      {!isReactNativeApp && (
        <Header
          $darkmode={false}
          indexId="ddfbf1ba66c5f0828ce406bad8ff5e4c1745832765"
        />
      )}
      {children}
      <Footer $darkmode={false} />
    </>
  );
};

export default Base;
